import confirmDialog from "./confirmDialog"
import {readyToLoadStore,tasksStore,transferStore} from './TasksStore';
import { get,update } from 'svelte/store'



export default class Gyre{



    getWeightsArray(prompt) {
        let promptArray = []

        let splitPrompt = prompt.split(/(\([^)]+\))/)
        for(let i=0;i<splitPrompt.length;i++) {
            let p=splitPrompt[i].trim()
            if (p) {
                let obj={prompt:p}
                promptArray.push(obj)
            }
        }
        for(let i=0;i<promptArray.length;i++) {
            let obj=promptArray[i]
            let item=obj.prompt
            let brackets = item.search(/\([^)]+\)/)
            if (!brackets) {
                let weight
                let bracketCount=item.split("(").length
                if (bracketCount>2) {
                    weight=(bracketCount-1)/10
                }
                item=item.replace(/\(/g,"")
                item=item.replace(/\)/g,"")
                let arr=item.split(":")
                if (!weight) weight=arr[1]
                if (!weight) weight=1.0
                obj.weight=parseFloat(weight)
                obj.prompt=arr[0]
            } else {
                item=item.replace(/\)/g,"")
                obj.prompt=item
                obj.weight=1
            }
        }
        console.log(promptArray)
        return promptArray
    }


    strip(str, remove) {
        while (str.length > 0 && remove.indexOf(str.charAt(0)) != -1) {
            str = str.substr(1)
        }
        while (str.length > 0 && remove.indexOf(str.charAt(str.length - 1)) != -1) {
            str = str.substr(0, str.length - 1)
        }
        return str
    }

    constructor() {
        window.onlyonegrpclocal = false;

    }
    getStatus() {
        return this.status
    }
    async runSD(SDConfig, p) {
        SDConfig.url=new URL(SDConfig.url).origin       // remove path at end
        SDConfig.url.endsWith('/') ? SDConfig.url.slice(0, -1) : SDConfig.url   // remove / at end

        this.status="waiting"

        let newServer=await this.checkNewServer(SDConfig)
        if (!newServer) window.onlyonegrpclocal=true
        else  window.onlyonegrpclocal=false

        if(window.onlyonegrpclocal && window.requestlocalgrpcprocessing && window.requestlocalgrpcprocessing == true) return
        console.log("specialLayersImageInfo",p.specialLayersImageInfo)

        const diffusionMap = {
            'DDIM': "SAMPLER_DDIM",
            'PLMS' : "SAMPLER_DDPM",
            'Euler' : "SAMPLER_K_EULER",
            'Euler a': "SAMPLER_K_EULER_ANCESTRAL",
            'Heun': "SAMPLER_K_HEUN",
            'DPM2': "SAMPLER_K_DPM_2",
            'DPM2 a': "SAMPLER_K_DPM_2_ANCESTRAL",
            'LMS': "SAMPLER_K_LMS",
            'DPMSolver++ 1 Order': "SAMPLER_DPMSOLVERPP_1ORDER",
            'DPMSolver++ 2 Order': "SAMPLER_DPMSOLVERPP_2ORDER",
            'DPMSolver++ 3 Order': "SAMPLER_DPMSOLVERPP_3ORDER",
            'DPM Fast':"SAMPLER_DPM_FAST",
            'DPM Adaptive':"SAMPLER_DPM_ADAPTIVE",
            'DPMSolver++ 2S a':"SAMPLER_DPMSOLVERPP_2S_ANCESTRAL",
            'DPMSolver++ SDE':"SAMPLER_DPMSOLVERPP_SDE",
            'DPMSolver++ 2M':"SAMPLER_DPMSOLVERPP_2M",
            'DPMSolver++ 2M (Fast)':"SAMPLER_DPMSOLVERPP_2M"
        }

        let images = []
        p.seedList = []
        let i = 0


        console.log(SDConfig)
        console.log("model",SDConfig.model)
        console.log("mode",p.mode)


        console.log("new server",newServer)
        if (!SDConfig.model) SDConfig.model="stable-diffusion-v1-5-standard"
        let modelList=await this.getModels(SDConfig);
        if (!modelList) {
            this.status="error"
            return
        }
        console.log(modelList)
        let found=false
        for(let i=0;i<modelList.length;i++) {
            let m=modelList[i]
            if (m.id===SDConfig.model) found=true
        }
        if (!found) {
            await new confirmDialog().alert("Model "+SDConfig.model+" not found. Please select model in configuration.")
            this.status="error"
            return
        }

        this.requestTemplate.engineId = SDConfig.model;

        this.requestTemplate.requestId = Math.floor(Math.random()*1000000000000)+"";
        //??this.requestTemplate.requestedType=  "ARTIFACT_NONE";

        let allprompts = [];

        let promptArray=this.getWeightsArray(p.prompt)
        for(let i=0;i<promptArray.length;i++) {
            let obj=promptArray[i]
            if (obj.prompt) {
                allprompts.push({text:obj.prompt,parameters:{weight:obj.weight}});
            }
        }


        if (p.negativePrompt) {
            allprompts.push({text:p.negativePrompt,parameters:{weight:-1}});
        }

        let uuid=Math.random().toString()
        let newprompt={}
        if (p.image64) {
            // @ts-ignore
            newprompt = {"parameters":{"init": true}};
            newprompt.artifact={uuid:uuid,type:"ARTIFACT_IMAGE",binary:p.image64}
            if (p.mode==="img2img" || p.mode==="inpainting"  || p.mode==="upscale") {
                allprompts.push(newprompt) // special type+img2img - ignore other image data

            }
        }
        if (p.mode==="removeBackground") {
            this.requestTemplate.engineId="noop"
            newprompt.artifact.adjustments=[{"background_removal":{ }}]
            allprompts=[newprompt]
            console.log("removeBackground",allprompts)
        }
        if (p.mode==="upscale") {
            this.requestTemplate.engineId=p.upscaleEngine
            if (p.prompt==="upscale") allprompts=[newprompt]    // some upscalers need prompt others not
        }
        if (p.mode=="inpainting" || p.mode=="inpainting_original") {
            if (p.maskImage64) {
                let promptMask = {artifact:{type:"ARTIFACT_MASK"}}
                promptMask.artifact.adjustments =  [{levels:{inputLow:0,inputHigh:0.01,outputLow:0,outputHigh:1}}];
                // gausian is no here ?
                promptMask.artifact.adjustments.push({blur:{sigma:32,direction:"DIRECTION_UP"}})

                promptMask.artifact.binary = p.maskImage64;
                // @ts-ignore
                allprompts.push(promptMask);
            } else {
                let promptMask = {artifact:{type:"ARTIFACT_MASK"}}

                promptMask.artifact.adjustments =  [
                    {"channels":{
                            "r": "CHANNEL_A",
                            "a": "CHANNEL_ONE"
                        }}
                ]

                promptMask.artifact.adjustments.push(
                    {"invert": { }}
                );
                promptMask.artifact.adjustments.push(
                    {
                        "blur": {
                            "sigma": 32,
                            "direction": "DIRECTION_UP"
                        },
                    });
                promptMask.artifact.binary = p.image64
                // @ts-ignore
                allprompts.push(promptMask)
            }
        }
        // special ControlNet and T2I information *******************************
        if (p.specialLayersImageInfo) {
            for (let specialLayer of p.specialLayersImageInfo) {
                let artifact = {type:"ARTIFACT_HINT_IMAGE","mime":"image/png"}
                // not using preprocssor/adjustments
                if (specialLayer.type==="skribble") artifact.hint_image_type="sketch"
                if (specialLayer.parameters && specialLayer.parameters.method && specialLayer.parameters.method==="T2I Adapter") {
                    artifact.hint_image_type="coadapter/sketch"
                }
                if (specialLayer.type==="segmentation") artifact.hint_image_type="segmentation/ade20k" // segmentation/coco not supported yet
                if (specialLayer.type==="posenet") artifact.hint_image_type="openpose"
                if (specialLayer.type==="depth") artifact.hint_image_type="depth"
                if (specialLayer.type==="inpaint") artifact.hint_image_type="inpaint"

                // image layer with preprocssor
                if (specialLayer.type==="image" && specialLayer.preprocessorType==="canny_edge") {
                    artifact.hint_image_type="controlnet/canny"
                    if (specialLayer.parameters && specialLayer.parameters.method && specialLayer.parameters.method==="T2I Adapter") {
                        artifact.hint_image_type="coadapter/canny"
                    }
                    artifact.adjustments=[{canny_edge :{
                            low_threshold: parseFloat(specialLayer.parameters.low_threshold),
                            high_threshold : parseFloat(specialLayer.parameters.high_threshold)
                        }
                    }]
                }
                if (specialLayer.type==="image" && specialLayer.preprocessorType==="depth") {
                    artifact.hint_image_type="depth"
                    artifact.adjustments=[{depth:{}}]
                    if (specialLayer.parameters && specialLayer.parameters.method && specialLayer.parameters.method==="T2I Adapter") {
                        artifact.hint_image_type="coadapter/depth"
                    }

                }
                if (specialLayer.type==="image" && specialLayer.preprocessorType==="hed") {
                    artifact.hint_image_type="hed"
                    artifact.adjustments=[{edge_detection:{}}]
                }
                if (specialLayer.type==="image" && specialLayer.preprocessorType==="lineart") {
                    artifact.hint_image_type="lineart"
                    artifact.adjustments=[{edge_detection:{},engine_id :"hinters-lineart-anime"}]
                }
                if (specialLayer.type==="image" && specialLayer.preprocessorType==="pix2pix") {
                    artifact.hint_image_type="pix2pix"
                }
                if (specialLayer.type==="image" && specialLayer.preprocessorType==="shuffle") {
                    artifact.hint_image_type="shuffle"
                    artifact.adjustments=[{shuffle:{}}]
                }
                if (specialLayer.type==="image" && specialLayer.preprocessorType==="normal") {
                    artifact.hint_image_type="normal"
                    artifact.adjustments=[{normal:{background_threshold:-1,preblur:0,postblur:5,smoothing:0.8}}]
                }
                if (specialLayer.type==="image" && specialLayer.preprocessorType==="segmentation") {
                    artifact.hint_image_type="segmentation/ade20k"
                    artifact.adjustments=[{segmentation:{}}]
                }
                if (specialLayer.type==="image" && specialLayer.preprocessorType==="posenet") {
                    artifact.hint_image_type="openpose"
                    artifact.adjustments=[{openpose:{}}]
                }
                if (specialLayer.parameters && specialLayer.parameters.preprocessor && specialLayer.parameters.preprocessor!=="normal") { // only preprocessor or skip it
                    if (specialLayer.parameters.preprocessor==="skip") artifact.adjustments=[]
                    if (specialLayer.parameters.preprocessor==="only") {
                        artifact.type="ARTIFACT_IMAGE"
                        this.requestTemplate.engineId="noop"
                        artifact.adjustments.push({"invert": { }})
                    }
                }
                // style is special
                if (specialLayer.type==="image" && specialLayer.preprocessorType==="style") {
                    artifact.hint_image_type="style"
                    if (specialLayer.parameters && specialLayer.parameters.method && specialLayer.parameters.method==="T2I Adapter") {
                        artifact.hint_image_type="coadapter/style"
                    }
                }
                artifact.binary=specialLayer.base64
                let weight=1.0
                let control_mode=0
                if (specialLayer.parameters && specialLayer.parameters.weight) weight=specialLayer.parameters.weight
                if (specialLayer.parameters && specialLayer.parameters.control_mode) {  // control_mode, https://github.com/hafriedlander/api-interfaces/blob/d2c6cfea753e58c1df408843904977ebeeed3d7e/src/proto/generation.proto#L314
                    switch(specialLayer.parameters.control_mode) {
                        case "Balanced": 
                            control_mode=0;
                            break;
                        case "My prompt is more important":
                            control_mode=1;
                            break;       
                        case "ControlNet is more important":
                            control_mode=2;
                            break;
                    }
                }
                if (specialLayer.type==="inpaint") control_mode=2 
                let prompt={artifact:artifact,parameters:{weight:weight,hint_priority:control_mode}}
                // @ts-ignore
                allprompts.push(prompt)
            }
        }
        if (p.loraList && p.mode!=="upscale" && p.mode!=="removeBackground"  && p.mode!=="inpainting") {
            for(let lora of p.loraList) {
                let artifact = {type:"ARTIFACT_LORA",url:lora.url}
                let prompt={artifact:artifact,parameters:{weight:lora.weight}}
                // @ts-ignore
                allprompts.push(prompt)
            }

        }
        console.log("allprompts",allprompts)


        this.requestTemplate.prompt = allprompts
        let width=parseInt(SDConfig.width)
        let height=parseInt(SDConfig.height)
        let imageobj = {}
        if (p.mode!=="upscale") {
            imageobj.width=width
            imageobj.height=height
            if (p.targetWidth && p.targetHeight) {      // not using config
                imageobj.width=parseInt(p.targetWidth)
                imageobj.height=parseInt(p.targetHeight)

            }
        }

        if (p.seed){
            imageobj.seed=[p.seed];
        }
        imageobj.steps = parseInt(p.steps);
        imageobj.samples = parseInt(p.num);



        /*            if (p.enable_hr) {  // ignored now
                        imageobj.hires ={enable:true}
                    } else {
                        imageobj.hires ={enable:false}
                    }*/
        imageobj.hires={enable:false}
        // auto activate hires fix
        if (imageobj.width>512 || imageobj.height>512)  imageobj.hires ={enable:true}
            //   image.setHiresFixParameters(hr)
        if (p.tiling){
            imageobj.tiling = true;
        }



        imageobj.transform={diffusion: diffusionMap[p.sampling_method]};

        // name of parameters = step
        let parameters = {scaledStep:0, sampler:{cfgScale:parseFloat(p.cfg_value)}}

        if (p.sampling_method==='DPMSolver++ 2M (Fast)') {
            parameters.sampler.sigma = {"sigmaMin": 0.1072,"karrasRho": 9}
        }

        if (p.image64 || p.maskImage64) {

            let schedule = {}
            if (!p.strength) p.strength=0.5
            if (!p.maskImage64){
                schedule.start=parseFloat(p.strength);
            }else{
                schedule.start=1.0;
            }

            if (p.inpainting_original) {
                schedule.start=parseFloat(p.strength);
            }
            parameters.schedule = schedule;
            //   console.log("strength set",p.strength,step.toObject())

        }
        try {
            if (p.clip) {
                parameters.guidance= {guidancePreset:"GUIDANCE_PRESET_NONE",}
                parameters.guidance.instances = [{"guidanceStrength": 0.25}];
            }
        } catch (e) {
            console.log(e)
        }
        imageobj.parameters = [parameters];
        this.requestTemplate.image = imageobj;
        let answers;


        let asyncHandleobj;
        asyncHandleobj = await this.postRest(SDConfig, 'asyncGenerate', this.requestTemplate);

        asyncHandleobj.requestId = this.requestTemplate.requestId;
        if (!window.asyncHandleobjList) window.asyncHandleobjList = [];
        window.asyncHandleobjList.push({...asyncHandleobj,taskid:p.taskid});
        let hasanyresult = false;
        while(!hasanyresult){
            let canceledfound = window.asyncHandleobjList.find((el)=>el.requestId==asyncHandleobj.requestId && el.canceled);
            if (canceledfound) break;
            try{
                answers = await this.postRest(SDConfig,'asyncResult',asyncHandleobj)
            }catch (e) {
                answers = {error:true,complete:true};
                throw e;
                break;
            }
            //if (answers && answers.error) return Promise.reject(new Error('Error'));
            if (answers && answers.answer && answers.answer.length)   hasanyresult = true;
            if (!hasanyresult){
                await new Promise(r => setTimeout(r, 1000));
            }
        }

        if (!answers.complete){
            if (window.postMessageAdapter || p.aistudio) {
                this.getAllOtherImagesStudio(SDConfig, p, asyncHandleobj);
            } else {
                this.getAllOtherImages(SDConfig, p, asyncHandleobj);
            }
        }


        if (answers.answer){
            answers = answers.answer;
        }


        if(window.onlyonegrpclocal) {
            window.requestlocalgrpcprocessing = false;
            readyToLoadStore.set({'ready':true});
        }


        if (!Array.isArray(answers)) answers = [answers];
        answers.forEach(answer=>{
            if (answer.artifacts) {
                answer.artifacts.forEach(
                    ({  type , binary, seed: innerSeed }) => {
                        if (type === 'ARTIFACT_IMAGE') {
                            if (!innerSeed) innerSeed=i
                            p.seedList[i] = innerSeed
                            let img = { base64: binary }
                            img.seed = p.seedList[i]
                            images.push(img)
                            i++
                        }
                    }
                )
                this.status="ready"
            }
        });
        return images;


        //return imgs
    }

    getAllOtherImagesStudio(SDConfig,p,asyncHandleobj){
        let that = this;
        let taskid = p.taskid;
        (async function() {
            let complete = false;
            while(!complete){
                await new Promise(r => setTimeout(r, 1000));
                let canceledfound = window.asyncHandleobjList.find((el)=>el.requestId==asyncHandleobj.requestId && el.canceled);
                if (canceledfound){
                    break;
                }
                let answers = await that.postRest(SDConfig,'asyncResult',asyncHandleobj);
                canceledfound = window.asyncHandleobjList.find((el)=>el.requestId==asyncHandleobj.requestId && el.canceled);
                let canceledrequest = canceledfound?true:false;
                if(answers) {
                    if (answers.answer){
                        let retobj = {taskid,answers};
                        if(canceledrequest){
                            retobj.canceledrequest = true;
                        }
                        transferStore.set(retobj);
                    }
                    if(answers.complete) complete = true;
                }
            }
        })();
    }

    async cancelRequest(SDConfig,taskid) {
        if (!window.asyncHandleobjList || !window.asyncHandleobjList.length) return;
        let found= window.asyncHandleobjList.find((el)=>el.taskid==taskid);
        found.canceled = true;
        let answer;
        try {
            answer = await this.postRest(SDConfig, 'asyncCancel',{requestId:found.requestId,asyncHandle:found.asyncHandle});
        } catch (e) {
            await new confirmDialog().alert(e.toString());
        }
    }

    getAllOtherImages(SDConfig,p,asyncHandleobj){
        let that = this;
        let taskid = p.taskid;
        (async function() {
            let complete = false;
            let answers
            let tasksarray
            while(!complete){
                await new Promise(r => setTimeout(r, 1000));
                let canceledfound = window.asyncHandleobjList.find((el)=>el.requestId==asyncHandleobj.requestId && el.canceled);
                if (canceledfound) break;
                try {
                    answers = await that.postRest(SDConfig, 'asyncResult', asyncHandleobj);
                }catch (e) {
                    await new confirmDialog().alert(e.toString());
                    complete=true;
                }
                if(!answers.answer) continue;
                tasksarray = get(tasksStore);
                let foundindex = 0 ;
                let eltoupdate = tasksarray.find((el,idx) => {foundindex= idx;  return el.p.taskid == taskid});

                if (!eltoupdate) continue;
                let res = answers.answer.map((el)=>{
                    let im = el.artifacts[0];
                    let base64 = "data:image/png;base64,"+im.binary;
                    let seed = im.seed;
                    return {base64,seed}
                })

                eltoupdate.imagelist = [...eltoupdate.imagelist,...res];
                if (answers.complete){
                    complete = true;
                    eltoupdate.complete = true;
                }
                tasksarray[foundindex] =  eltoupdate;
                tasksStore.set(tasksarray);
            }
        })();
    }


    getSpecialFeatures(model,upscalers) {
        let list=["canny","style","skribble","depth","normal","hed","posenet","segmentation","shuffle","pix2pix","normal","T2I_ControlNet_canny_switch","pix2pix","backgroundRemoval","text","control_mode"]
        let features=[]
        if (!model.acceptedHintTypes) {
            if (upscalers) return list  // default: all features
            return features             // old 1.1 server has no upscaler -> nothing else as well
        }
        for(let hType of model.acceptedHintTypes) {
            for(let f of list) {
                let toFind=f
                if (f==="skribble") toFind="scribble"
                if (f==="posenet") toFind="openpose"

                if (hType.type===toFind) {
                    features.push(f)
                    if (toFind==="canny") features.push("T2I_ControlNet_canny_switch")
                    if (toFind==="scribble") features.push("text")

                } 
            }
        }
        if (features) {
            features.push("backgroundRemoval")
            features.push("control_mode")
        }

        return features
    }
    async getServerFeatures(SDConfig) {
        try {

            let models=await this.getModels(SDConfig)
            console.log("models",models)
            if (!models) return false
            let upscalers
            upscalers=await this.postRest(SDConfig, 'engines', {task_group :"UPSCALE"},true);
            let features={}
            let modelFound=false
            for(let i=0;i<models.length;i++) {
                let model=models[i]
                if (model.id===SDConfig.model) {
                     features={artifacts:model.acceptedPromptArtifacts,models:models,model:model.id,upscalers,features:this.getSpecialFeatures(model,upscalers)}
                     modelFound=true
                }
            }

            if (modelFound)       return features

            let model=models[0]
            if (!model) return false
            features={artifacts:model.acceptedPromptArtifacts,models:models,model:model.id,upscalers,features:this.getSpecialFeatures(model,upscalers)}
            return features
        } catch(e) {
            return false
        }
    }










    async postRest(SDConfig,command,body,ignoreError=false) {
        SDConfig.url=new URL(SDConfig.url).origin       // remove path at end
        SDConfig.url.endsWith('/') ? SDConfig.url.slice(0, -1) : SDConfig.url   // remove / at end        
        let apiKey = "";
        if (SDConfig.token) apiKey = "/"+SDConfig.token     // temp quick fix

        let endpoint =SDConfig.url+apiKey+"/grpcgateway/"+command;
        let answer;
        let answertext;
        let postRequest
        if (SDConfig.token)    apiKey = SDConfig.token        
        try {
            postRequest= await fetch(endpoint, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                 //   "Authorization": `Bearer ${apiKey}`,
                    "Bypass-Tunnel-Reminder": `true`,                    
               //     "Access-Control-Allow-Credentials": `true`                    
                },
                method: 'POST',
                body: JSON.stringify(body)
            })
            //answer=await postRequest.json();
            answertext =await postRequest.text();
            try {
                answer= JSON.parse(answertext);
            } catch(error) {
                throw SyntaxError(error);
            }
            if (postRequest.status>400){
                answertext = answer.name+" "+answer.messsage;
                throw SyntaxError();
                return;
            }
            if (answer) {
                return answer
            }
            return false

        } catch(error) {
            if (ignoreError) return
            if (error instanceof SyntaxError) {
                let errortext;
                if(answertext) errortext = answertext.replace(/<[^>]+>/g, '');
                if (!errortext && postRequest.statusText) errortext = "Server error: "+postRequest.statusText;
                if(!errortext) errortext = error.toString();
                await new confirmDialog().alert(errortext);
                throw error;
            } else {
                await new confirmDialog().alert(error.toString())
                console.log(error,postRequest)
                this.status="error"
                throw error;
            }
        }
    }




    async getModels(SDConfig) {
        SDConfig.url=new URL(SDConfig.url).origin       // remove path at end
        SDConfig.url.endsWith('/') ? SDConfig.url.slice(0, -1) : SDConfig.url   // remove / at end        

        let answertext;
        let apiKey = "";
        if (SDConfig.token) apiKey = "/"+SDConfig.token

        let endpoint =SDConfig.url+apiKey+"/grpcgateway/engines"
        let answer;
        let getRequest;
        try {
            getRequest= await fetch(endpoint, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                 //   "Authorization": `Bearer ${apiKey}`,
                    "Bypass-Tunnel-Reminder": `true`,
                //    "Access-Control-Allow-Credentials": `true`
                },
                method: 'get'
            })
            answertext =await getRequest.text();
            try {
                answer= JSON.parse(answertext);
            } catch(error) {
                throw SyntaxError(error);
            }

            if (answer.engine) {
                let res=[]
                console.log("getModels",answer)
                for (let i=0;i<answer.engine.length;i++) {
                    let engine=answer.engine[i]
                    if (engine.type==="PICTURE")    res.push(engine)
                }
                return res
            }
            return false
        } catch(error) {
            if (error instanceof SyntaxError) {
                let errortext;
                if(answertext) errortext = answertext.replace(/<[^>]+>/g, '');
                if (!errortext && getRequest.statusText) errortext = "Server error: "+getRequest.statusText;
                if(!errortext) errortext = error.toString();
                await new confirmDialog().alert(errortext)
            } else {
                await new confirmDialog().alert(error.toString())
                console.log(error,getRequest)
                this.status="error"
                throw error;
            }
        }
    }


    async checkNewServer(SDConfig) {
        return await this.getModels(SDConfig)
    }

    requestTemplate={}

}